export enum TransactionType {
  WIN = 1,
  BET = 2,
}
